module.exports = __webpack_public_path__ + "img/email.8f659817.svg";